module.exports = __webpack_public_path__ + "img/RCloudHA.a79c4250.png";